/* Add CustomFields Sep 23, 2023 */
/* Add kt-notes,d_savedRecord Feb 29, 2024 */
/* Add Voice Processing June 1, 2024 */
/* Add  readonly, required columns Jan 25, 2025 */
/* Add Add uper container for photo and name Dec 11, 2025 */
/* Add vcrec, eventBus and contactUpload    May 30, 2026 */
/* GUI Changes Pase 1 May 15, 2026 */
<template lang="pug">
	div
		rec-wrap(:p_mode="p_mode" :p_saveFn="m_saveFn" p_appEntKey="extr" :p_isModal="p_isModal" 
		:p_requiredColumns="d_requiredColumns" :p_recData="d_recData" :p_altView="d_altViewKey" 
		@altViewChg="d_altViewKey = $event" @focused="d_currentFocus = $event" @voice="m_processVoice" @contactUpload="m_processUpload") 
				template(v-slot:rec-form-header)
					div(class="d-flex raisedHeader")
						div(class="form-group"  style="text-align:left;width:20%" )
							kt-photo(id="contactPhoto" ref="kt-photo" p_prntRecKey="extr" :p_recInfo="c_recInfo" :p_photoRec="c_photoRec")
						div(class="d-flex flex-column justify-content-center")
							<span class="d-block" style="color:#4fa4ff;font-size:25px;">{{d_recData.externalContactName}}</span>
							<span v-if="d_recData.role" class="d-block" style="color:#4fa4ff;font-size:18px;">{{d_recData.role}}</span>
				template(v-slot:rec-form-left)
					span <span style="color:#ff9333;">*</span>indicates field is required.
					div(class="form-group")
						label(class="required-label") Contact #
						b-form-input(class="styled-input" id="externalContactNo" size="sm"  v-model="d_recData.externalContactNo" disabled placeholder="Auto Generated"  )
					div(class="form-group")
						label(class="required-label") Contact Name
						b-form-input(class="styled-input" id="externalContactName" size="sm"  v-model="d_recData.externalContactName" required)
					div(class="form-group")
						label(:class="m_required('role')?'required-label':''") Title/Role
						b-form-input(class="styled-input" id="role" size="sm"  v-model="d_recData.role" )
					div(class="form-group")
						label(:class="m_required('address')?'required-label':''") Address
						b-form-textarea(class="styled-input" id="address" size="sm"  v-model="d_recData.address" rows=3 no-resize )
				template(v-slot:rec-form-right)
					div(class="form-group" v-if="!d_hideAccts")
						label(:class="m_required('accounts')?'required-label':''") Account(s)
						kt-list(id="accounts"
								p_appEntKey="acct"
								:p_currentVals="d_recData.accounts"
								:p_readOnly="p_mode=='view'||m_readOnly('accounts')"
								:p_enableCreate="false"
								:p_enableAdd="true"
								@change="d_recData.accounts = $event"
							)
						span(class="note") Account(s) the contact is associated with
					div(id="teammembers" class="form-group fg-500" )
						label(:class="m_required('teamMembers')?'required-label':''") Contact Owner(s)
							kt-list(id="teamMembers"
								p_appEntKey="team"
								:p_currentVals="d_recData.teamMembers"
								:p_readOnly="p_mode=='view'||m_readOnly('teamMembers')"
								:p_enableCreate="false"
								:p_enableAdd="true"
								@change="d_recData.teamMembers = $event"
								)
					div(class="form-group")
						label(:class="m_required('phoneNo')?'required-label':''") Phone #s
							kt-com-fld(id="phoneNo" :p_mode="p_mode" typ="p" :p_readOnly="m_readOnly('phoneNo')" v-model="d_recData.phoneNo" placeholder="Direct")
							kt-com-fld(id="officePhoneNo" :p_mode="p_mode" typ="f" :p_readOnly="m_readOnly('officePhoneNo')" v-model="d_recData.officePhoneNo" placeholder="Office")
							kt-com-fld(id="mobilePhoneNo" :p_mode="p_mode" typ="pm" :p_readOnly="m_readOnly('mobilePhoneNo')" v-model="d_recData.mobilePhoneNo" placeholder="Mobile")
							kt-com-fld(id="otherPhoneNo" :p_mode="p_mode"  typ="po" :p_readOnly="m_readOnly('otherPhoneNo')" v-model="d_recData.otherPhoneNo" placeholder="Other phone")
					div(class="form-group")
						label(:class="m_required('email')?'required-label':''") Email
						kt-com-fld(id="email" :p_readOnly="m_readOnly('email')" typ="@" v-model="d_recData.email")
					div(class="form-group")
						b-form-checkbox(id="inactive" :value="true" v-model="d_recData.inactive") Inactive
				template(v-slot:rec-form-center)
					div(class="form-group")
						label(:class="m_required('externalContactDetails')?'required-label':''") Contact Details
						b-input-group-prepend(class="px-0")
							b-input-group-text
								fa-icon(icon="list-ul")
							b-form-textarea(class="styled-input" id="externalContactDetails" size="sm"  v-model="d_recData.externalContactDetails" rows=5)
					kt-custom-field(v-if="d_customFields.length>0" :p_mode="p_mode" p_prntRecKey="extr"  :p_recData="d_recData.customData"  @change="d_recData.customData=$event")
				template(v-slot:rec-alt-view)
					kt-related(v-if="d_altViewKey=='RR'" :p_relatedGrids="m_relatedGrids()" )
</template>

<script>

import {fn_getHashId} from "@/utils/util.js";
import {fn_saveRecord} from "@/utils/api.js";
import RecWrap from "@/components/RecWrap.vue";
import KTList from "@/components/Ctrl/KT-List.vue";
import KTRelated, {RelatedGridClass, getColFns} from "@/components/Ctrl/KT-Related.vue";
import KTCustomField from "@/components/Ctrl/KT-CustomField.vue";
import {refData,userSettings} from "@/utils/ref-data.js";
import { eventBus } from '@/main';
export default {
	name: "extr-rec",
	components: {
		'rec-wrap': RecWrap,
		'kt-related': KTRelated,
		'kt-list': KTList,
		'kt-custom-field': KTCustomField,
		'kt-photo': () => import("@/components/Ctrl/KT-Photo.vue"),		
	},
	created() {
		if (this.p_mode != 'create' && !this.p_recNo) {
			this.d_recNo = fn_getHashId(this);
		}
		else if (this.p_recNo) {
			this.d_recNo = this.p_recNo;
		}
		if (this.p_mode == 'create') {
			let rwPrnt = this.$parent.$parent.$parent;
			if (!rwPrnt.p_appEntKey) return;

			//To pre-populate "Account" KT-List when being added from parent record (acct, oppr, proj)
			let rd = rwPrnt.p_recData;
			if (rwPrnt.p_appEntKey == 'acct') {
				if (rd.accountId) {
					let acct = {
						accountId: rd.accountId,
						accountNo: rd.accountNo,
						accountName: rd.accountName,
					};
					this.d_recData.accounts = [acct];
				}
				else {
					this.d_hideAccts = true; //If new Account, hide to avoid confusion. Contact will be added when account is saved.
				}
			}
			else if (/^(oppr|proj)$/.test(rwPrnt.p_appEntKey) && (rd.clientAccount || {}).accountId) {
				this.d_recData.accounts = [{...rd.clientAccount}];
			}
		}
		var usrOpts = userSettings.userOptions;
		this.d_readOnlyColumns=usrOpts['tableReadOnlyColumns']['kt-table-extr'];
		this.d_requiredColumns=usrOpts['tableRequiredColumns']['kt-table-extr'];
		
		
		eventBus.$on('contactUpload', (data) => {
							this.d_recData={...data};
							this.d_recData.contactDetails=`Company Name: ${data.companyName}, others: ${data.otherDetails}`;
						});
	},
	mounted() {
	
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
				


					Array.from(document.getElementsByTagName('input')).forEach(i=>
								{
								console.log(i.id);
								var _this=this;
								i.addEventListener("focus", (event) => {
								this.$emit("focused",i.id);
								});
								
								});	
	
	},
	data() {
		return {
			d_recNo: null,
			d_recData: {},
			d_altViewKey: null,
			d_hideAccts: null,
			d_customFields:refData.customFields.filter(c=>(c.context=='extr')),
			d_savedRecord:null,
			d_currentFocus:null,
			d_readOnlyColumns:[],
			d_requiredColumns:[],
		};
	},
	provide() {return {vcrec: this}},
	props: {
		p_recNo: String,
		p_mode: String,
		p_isModal: Boolean,
	},
	computed: {
	c_recInfo() {
      let rd = this.d_recData;
      return {
        Id: rd.externalContactId,
        No: rd.externalContactNo,
        Name: rd.externalContactName,
      };
    },
	c_photoRec() {
			let rd = this.d_recData;
			return {
				photoId: rd.photoId,
				photoURL: rd.photoURL,
				photoName: rd.photoName
			};
		},	
	
	
	},
	methods: {
		m_saveFn() { //Called from  RecWrap, KTList, KTSelect
			let id = this.p_mode == 'edit' ? this.d_recData.externalContactId : null;
			this.d_savedRecord=true;
			return fn_saveRecord('contact', id, this.d_recData);
			
		},
		m_relatedGrids() {
			let fPCC = {key: 'pcc', label: 'Primary Client Contact', paramNm: 'externalContactId'};
			let fAC = {key: 'ac', label: 'Account Contact', paramNm: 'externalContactId'};

			let recId = this.d_recData.externalContactId;
			let recNm = this.d_recData.externalContactName;

			let rOppr = new RelatedGridClass('extr', recId, recNm, 'oppr', getColFns.oppr, [fPCC]);
			let rproj = new RelatedGridClass('extr', recId, recNm, 'proj', getColFns.proj, [{...fPCC}]); //Need to cpoy
			let racct = new RelatedGridClass('extr', recId, recNm, 'acct', getColFns.acct, [fAC]);

			return [rOppr, rproj, racct];
		},
		m_processVoice(e){	
							document.getElementById(this.d_currentFocus).value=e;
						},
		m_readOnly(col){return false;},
		m_readOnly1(col){return this.d_readOnlyColumns||[].includes(col);},
		m_required(col){return this.d_requiredColumns||[].includes(col);},	
		m_processUpload(data){
		
			console.llog('In m_processUpload');
			console.log(data);
			
			Object.keys(data).forEach(k => {
				var el = k=="otherInformation"?"externalContactDetails":k;
				if (data[k] !== null && data[k] !== undefined) {
					if(k=="otherInformation") this.d_recData.externalContactDetails += data[k];
					else this.d_recData[k] = data[k];
					document.getElementById(el).classList.add("uploaded");
					}
				});
		},
	},
  watch: {
 	p_mode(nv) {
			if(nv == 'create' || nv=='edit'){
				//- Read Only Columns.
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
			}
		}, 
  },
  
};


</script>
<style lang="less">
.uploaded {background-color:yellow !important;  //light green: #90ee90
		color:black;
}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
.raisedHeader{
	position1:fixed;
	width:1130px;
	padding: 10px;
	background-color: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
	border-radius: 8px;
	z-index1: 9;
	}
.raisedHeader img {
	border-radius: 8px;
}
.raisedHeader .d-flex {
  align-items: center;
}
</style>